import * as React from "react"
import { useContentfulInspectorMode } from "@contentful/live-preview/react"
import H3 from "../atoms/typography/H3"
import { QuoteModel } from "./models"
import Body from "../atoms/typography/Body"
import { Col, Row } from "react-grid-system"
import { HorizontalSpacer } from "../atoms/spacers"
import PageContentWrapper from "../organisms/PageContentWrapper"

const Quote: React.FunctionComponent<QuoteModel> = (props) => {
  const inspectorProps = useContentfulInspectorMode()
  return (
    <PageContentWrapper>
      <Row justify="center" {...inspectorProps({ fieldId: "text", entryId: props?.sys?.id })}>
        <Col xs="content">
          <HorizontalSpacer spacing={1.5} />
          <i>
            <H3 textAlign="center">"{props.text}"</H3>
          </i>
          <HorizontalSpacer spacing={1} />
          <H3 textAlign="center">- {props.author}</H3>
          {props.title && <Body textAlign="center">{props.title}</Body>}
          <HorizontalSpacer spacing={1.5} />
        </Col>
      </Row>
    </PageContentWrapper>
  )
}

export default Quote
